/**
 * --------------------------------------------
 * KANYOS ContentSideNav.js
 * License ANZAS
 * --------------------------------------------
 */

import $ from 'jquery'

/**
 * Constants
 * ====================================================
 */

const NAME = 'ContentSideNav'
const DATA_KEY = 'lte.contentsidenav'
const EVENT_KEY = `.${DATA_KEY}`
const JQUERY_NO_CONFLICT = $.fn[NAME]

const EVENT_COLLAPSED = `collapsed${EVENT_KEY}`
const EVENT_SHOWN = `shown${EVENT_KEY}`

const CLASS_NAME_CARD = 'content-side-nav-card'
const CLASS_NAME_TOOL = 'content-side-nav-tool'
const CLASS_NAME_COLLAPSE = 'content-side-nav-collapse'
const CLASS_NAME_EXPAND = 'content-side-nav-expand'
const CLASS_NAME_TOOL_BUTTON = `${CLASS_NAME_TOOL} btn btn-xs btn-tool btn-default btn-flat border-top-0 border-right-0 border-bottom-0 m-0 p-0 h-100 d-flex align-items-center`

const SELECTOR_TOGGLE_BUTTON = '[data-widget="content-side-nav"]'
const SELECTOR_MAIN_HEADER = '.main-header'
const SELECTOR_MAIN_FOOTER = '.main-footer'
const SELECTOR_CONTENT_WRAPPER_HEADER = '.content-wrapper .content-header'
const SELECTOR_CONTENT_SIDE_NAV = '.content-side-nav'
const SELECTOR_CONTENT_SIDE_NAV_CARD = `${SELECTOR_CONTENT_SIDE_NAV} .${CLASS_NAME_CARD}`
const SELECTOR_CONTENT_SIDE_NAV_TOOL = `${SELECTOR_CONTENT_SIDE_NAV} .${CLASS_NAME_TOOL}`

const Default = {
  collapseEnabled: true,
  collapseIcon: 'oi oi-collapse-left',
  expandIcon: 'oi oi-caret-right'
}

/**
 * Class Definition
 * ====================================================
 */

class ContentSideNav {
  constructor(element, options) {
    this._element = element
    this._options = $.extend({}, Default, options)

    this._init()
  }

  // Public

  expand() {
    this._removeNavToolButton()

    setTimeout(() => {
      $(SELECTOR_CONTENT_SIDE_NAV_CARD).show()
    }, 300)

    const $contentSideNav = $(SELECTOR_CONTENT_SIDE_NAV)
    if ($contentSideNav.hasClass(CLASS_NAME_COLLAPSE)) {
      $contentSideNav.removeClass(CLASS_NAME_COLLAPSE)
    }

    $contentSideNav.addClass(CLASS_NAME_EXPAND)

    $(this._element).trigger($.Event(EVENT_COLLAPSED))
  }

  collapse() {
    this._addNavToolButton()

    setTimeout(() => {
      $(SELECTOR_CONTENT_SIDE_NAV_CARD).hide()
    }, 300)

    const $contentSideNav = $(SELECTOR_CONTENT_SIDE_NAV)
    if ($contentSideNav.hasClass(CLASS_NAME_EXPAND)) {
      $contentSideNav.removeClass(CLASS_NAME_EXPAND)
    }

    $contentSideNav.addClass(CLASS_NAME_COLLAPSE)

    $(this._element).trigger($.Event(EVENT_SHOWN))
  }

  toggle() {
    const $contentSideNav = $(SELECTOR_CONTENT_SIDE_NAV)
    if ($contentSideNav.hasClass(CLASS_NAME_COLLAPSE)) {
      this.expand()
    } else {
      this.collapse()
    }
  }

  // Private

  _init() {
    if (this._options.collapseEnabled &&
      $(SELECTOR_TOGGLE_BUTTON).find('i').length === 0) {
      $(SELECTOR_TOGGLE_BUTTON).append($('<i />', {
        class: this._options.collapseIcon
      }))
    }
  }

  _removeNavToolButton() {
    const $tool = $(SELECTOR_CONTENT_SIDE_NAV_TOOL)
    if ($tool.length > 0) {
      $tool.remove()
    }
  }

  _addNavToolButton() {
    const $tool = $(SELECTOR_CONTENT_SIDE_NAV_TOOL)
    if ($tool.length > 0) {
      return
    }

    const $window = $(window)
    const $mainHeader = $(SELECTOR_MAIN_HEADER)
    const $mainFooter = $(SELECTOR_MAIN_FOOTER)
    const $contentHeader = $(SELECTOR_CONTENT_WRAPPER_HEADER)

    const heights = {
      window: $window.outerHeight(),
      mainHeader: $mainHeader.length > 0 ? $mainHeader.outerHeight() : 0,
      mainFooter: $mainFooter.length > 0 ? $mainFooter.outerHeight() : 0,
      contentHeader: $contentHeader.length > 0 ? $contentHeader.outerHeight() : 0
    }

    const $toolButton = $('<button />', {
      class: CLASS_NAME_TOOL_BUTTON
    })
    $toolButton.css({
      minHeight: heights.window - heights.mainHeader - heights.mainFooter - heights.contentHeader
    })
    $toolButton.prepend($('<i />', {
      class: this._options.expandIcon
    }))
    $toolButton.on('click', () => {
      this.toggle()
    })

    const $contentSideNav = $(SELECTOR_CONTENT_SIDE_NAV)
    $contentSideNav.prepend($toolButton)
  }

  // Static

  static _jQueryInterface(operation) {
    return this.each(function () {
      let data = $(this).data(DATA_KEY)
      const _options = $.extend({}, Default, $(this).data())

      if (!data) {
        data = new ContentSideNav(this, _options)
        $(this).data(DATA_KEY, data)
      }

      if (typeof operation === 'string' && /collapse|expand|toggle/.test(operation)) {
        data[operation]()
      }
    })
  }
}

/**
 * Data API
 * ====================================================
 */

$(document).on('click', SELECTOR_TOGGLE_BUTTON, event => {
  event.preventDefault()

  let button = event.currentTarget

  if ($(button).data('widget') !== 'contentsidenav') {
    button = $(button).closest(SELECTOR_TOGGLE_BUTTON)
  }

  ContentSideNav._jQueryInterface.call($(button), 'toggle')
})

$(window).on('load', () => {
  ContentSideNav._jQueryInterface.call($(SELECTOR_TOGGLE_BUTTON))
})

/**
 * jQuery API
 * ====================================================
 */

$.fn[NAME] = ContentSideNav._jQueryInterface
$.fn[NAME].Constructor = ContentSideNav
$.fn[NAME].noConflict = function () {
  $.fn[NAME] = JQUERY_NO_CONFLICT
  return ContentSideNav._jQueryInterface
}

export default ContentSideNav
